// Pages.js

import About from "../pages/About";
import Skills from "../pages/Skills";
import Projects from "../pages/Projects";
import WorkExperience from "../pages/WorkExperience";
import Contact from "../pages/Contact";
import GalaxyAnimation from "../pages/GalaxyAnimation";

const Pages = {
  About,
  Skills,
  Projects,
  WorkExperience,
  Contact,
  GalaxyAnimation,
};

export default Pages;
